import { render, staticRenderFns } from "./Template-07.vue?vue&type=template&id=a99479e4&scoped=true&"
import script from "./Template-07.vue?vue&type=script&lang=js&"
export * from "./Template-07.vue?vue&type=script&lang=js&"
import style0 from "./Template-07.vue?vue&type=style&index=0&id=a99479e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99479e4",
  null
  
)

export default component.exports